var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['tui-switch', _vm.value ? 'tui-switch-checked' : 'tui-switch-no-checked']})
}
var staticRenderFns = []

export { render, staticRenderFns }